/*
 * HappyAlert controller (React Native)
 * ------------------------------------------------------------------
 * Module-level event bus that lets ANY file fire a premium alert without
 * needing the React tree / context. The single <HappyAlertHost /> mounted
 * in AppProviders subscribes here and renders the modal.
 *
 * Requests are queued, so rapid-fire alerts show one after another instead
 * of clobbering each other.
 */

let listener = null;
const queue = [];

export const HappyAlertController = {
    /** Called by the host. Returns an unsubscribe fn and flushes any queued requests. */
    subscribe(fn) {
        listener = fn;
        if (queue.length) {
            const pending = queue.splice(0, queue.length);
            pending.forEach((cfg) => fn(cfg));
        }
        return () => {
            if (listener === fn) listener = null;
        };
    },

    /** Enqueue an alert. Buffered until the host is mounted. */
    show(config) {
        if (listener) listener(config);
        else queue.push(config);
    },

    /** Programmatically dismiss the current alert. */
    hide() {
        if (listener) listener({ __dismiss: true });
    },
};

export default HappyAlertController;
